import { TableProps } from "antd";
import { useParams } from "react-router-dom";
import CustomTable from "../../../../../components/ui/CustomTable";
import { useGetVendorActivityLogQuery } from "../../../../../features/Vendor/vendor.api";
import useTable from "../../../../../hooks/useTable";
import { formatDate, formatTime } from "../../../../../lib/time";
import { addKeyInArray } from "../../../../../utils/utils";

const ActivityLog = () => {
  const { id } = useParams();
  const { page, limit, handleLimit, handlePagination } = useTable<{
    status: string;
  }>({});
  const {
    data: activityLogs,
    isLoading,
    isFetching,
  } = useGetVendorActivityLogQuery({
    id: id as string,
    params: { page, limit },
  });
  const columns: TableProps<any>["columns"] = [
    {
      title: "Date & Time",
      dataIndex: "created_at",
      width: 200,
      render: (val) => (
        <div>
          <span className="text-sm text-theme-gray-24 font-medium block">
            {formatDate(val)}
          </span>
          <span className="text-xs text-theme-gray-24 block">
            {formatTime(val)}
          </span>
        </div>
      ),
    },
    {
      title: "Date & Time",
      render: (val) => (
        <div>
          <span className="text-sm text-theme-gray-24 font-medium block">
            {val?.title}
          </span>
          <span className="text-xs text-theme-gray-24 block">
            {val?.text}
          </span>
        </div>
      ),
    },
  ];
  return (
    <div className="mt-6">
      <CustomTable
        title={"Activity Log"}
        loading={isLoading || isFetching}
        limit={limit}
        page={page}
        columns={columns}
        total={activityLogs?.data.totalLength}
        dataSource={addKeyInArray(activityLogs?.data?.activities || [])}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        hideDifferentRowColor
      />
    </div>
  );
};

export default ActivityLog;
